<script setup>
import { ref, computed,watch } from 'vue';
import { useQuasar, QVideo } from 'quasar';
const $q = useQuasar();
const darkMode = ref($q.dark.isActive);

watch(() => $q.dark.isActive, (newVal) => {
    darkMode.value = newVal;
});
const isLargeScreen = computed(() => $q.screen.gt.xs);
const videoVisible = ref(false);


useHead({
    title: 'Customer Conversations - OnSight Optical',
    meta: [
        { name: 'description', content: 'Article from Automation and Robotics about OnSight Optical investing in the first A&R ProMapper Block.' }
    ]
})
</script>

<template>
    <div class="row justify-center q-mt-lg q-mb-lg" style="margin-top: 40px;">
        <div class="col-11 col-md-6">
            <div :class="['text-h3 text-left', darkMode ? 'text-grey-5' : 'text-brand']"><strong>Customer Conversations - OnSight Optical</strong></div>
            <div :class="['text-h5 text-left', darkMode ? 'text-grey-5' : 'text-brand']">By Automation & Robotics</div>
            <div :class="['text-h5 text-left', darkMode ? 'text-grey-5' : 'text-brand']">Automation & Robotics - November 26, 2020</div>
            <div style="font-size: 18px;">
                <a :class="darkMode ? 'text-grey-5' : ''" href="https://www.ar.be/en/news/item/4-customer-conversations-onsight-optical.html"
                    target="_blank">https://www.ar.be/en/news/item/4-customer-conversations-onsight-optical.html</a>
            </div>

            <br>
            <div :class="darkMode ? 'text-grey-5' : 'text-brand'">
                <p style="font-size: 20px;">OnSight invested in the first A&R ProMapper Block, an easy-to-use table-top
                    solution providing optical inspection according to industry standards.</p>
                <p style="font-size: 20px;">Freeform surface evaluation based on the A&R Error Map technology ensures no
                    surface defect leaves the lab.</p>
                <p style="font-size: 20px;">Founded by Mike Shane more than 25 years ago, OnSight Optical in Clearwater Florida manages
                    approximately
                    60 optometric centers for ophthalmologists around the country. OnSight not only provides lenses, but
                    stocks the frames as well for patients. "We look at every tray as a patient's face," says Shane.
                    OnSight is also the nation's largest pediatric optical lab.</p>
                <p style="font-size: 20px;">Lee Murray, Manager of Lab Operations at OnSight, says "We believe we better have the best equipment
                    because we're working with surgeons. Our goal is to match their level of care with the best lenses
                    possible using the highest level of technology." That's why they invested in the ProMapper Block
                    from A&R Optical.</p>
                <p style="font-size: 20px;">"Before the ProMapper, you couId be doing poor work and not know it. The ProMapper provides a complete
                    map or picture of each lens, especially important for progressive and digital lenses. And it gives
                    the operator real-time insight into lens production. lt accurately diagnoses where in the production
                    the process fails. It can tell you if a diamond is dull.We feel more confident and proud of the high
                    quality work we're doing,and we can help our opticians diagnose with confidence. OnSight is
                    a Varilux lab and has always offered the highest technology from Essilor. A&R and Essilor share
                    encrypted software data. This allows the ProMapper to diagnose lenses accurately. A&R has helped us
                    become a better customer and a better partner. We
                    think their attention to detail is the best in the industry. In fact nobody should open a lab without
                    a ProMapper. "</p>
            </div>
        </div>
    </div>
</template>